export default __webpack_public_path__ + "static/media/search.85156ffb.svg";